import type { ColorPalette } from '../ColorPalette';
import { User } from '../User';
import type { Unsubscribe } from '../types';
import { AbstractMode } from './AbstractMode';

/**
 * OS / browser preference mode (appearance preset: system).
 */
export class SystemColorMode extends AbstractMode {
	private unsubscribeColorScheme: Unsubscribe | null = null;

	constructor(
		private readonly darkPalette: ColorPalette,
		private readonly lightPalette: ColorPalette
	) {
		super();
		this.unsubscribeColorScheme = User.instance().onColorSchemeChange(() => {
			this.notifyPaletteStale();
		});
	}

	currentPalette(): ColorPalette {
		return User.instance().prefersDarkScheme() ? this.darkPalette : this.lightPalette;
	}

	type(): string {
		return 'system';
	}

	protected onDispose(): void {
		this.unsubscribeColorScheme?.();
		this.unsubscribeColorScheme = null;
	}
}
